"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("../../styles");
const sharedStyles_1 = __importDefault(require("../sharedStyles"));
const styles = styles_1.createStyles((theme) => {
    const _a = sharedStyles_1.default(theme), { row } = _a, rest = __rest(_a, ["row"]);
    return Object.assign(Object.assign({}, rest), { root: Object.assign(Object.assign(Object.assign({}, row), theme.typography.caption), { fontWeight: theme.typography.weights.semiBold, position: 'sticky', top: 0, zIndex: 1, boxShadow: theme.shadows[1], backgroundColor: theme.palette.background }) });
});
exports.default = styles_1.withStyles(styles);
